import React from 'react';
import { Box, Container, Typography, Stack, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { NavBar } from '../NavBar';
import { tokens } from '../../theme';
import { useTranslation } from 'react-i18next';

export const PublicLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: tokens.color.bg, display: 'flex', flexDirection: 'column' }}>
      <NavBar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Box component="footer" sx={{
        borderTop: `1px solid ${tokens.color.border}`,
        py: 4,
        backgroundColor: tokens.color.surface,
      }}>
        <Container maxWidth="lg">
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} justifyContent="space-between">
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                Email<Box component="span" sx={{ color: tokens.color.accent }}>Validator</Box>
              </Typography>
              <Typography variant="body2" sx={{ color: tokens.color.textSecondary, maxWidth: 280 }}>
                {t('footer.tagline')}
              </Typography>
            </Box>
            <Stack direction="row" spacing={4}>
              <Stack spacing={1}>
                <Typography variant="caption" sx={{ color: tokens.color.textMuted, textTransform: 'uppercase', fontWeight: 600 }}>
                  {t('footer.product')}
                </Typography>
                <MuiLink component={RouterLink} to="/pricing" sx={{ color: tokens.color.textSecondary }}>{t('nav.pricing')}</MuiLink>
                <MuiLink component={RouterLink} to="/api-docs" sx={{ color: tokens.color.textSecondary }}>{t('nav.apiDocs')}</MuiLink>
                <MuiLink component={RouterLink} to="/status" sx={{ color: tokens.color.textSecondary }}>{t('nav.status')}</MuiLink>
              </Stack>
              <Stack spacing={1}>
                <Typography variant="caption" sx={{ color: tokens.color.textMuted, textTransform: 'uppercase', fontWeight: 600 }}>
                  {t('footer.tools')}
                </Typography>
                <MuiLink component={RouterLink} to="/tools/email-validate" sx={{ color: tokens.color.textSecondary }}>{t('nav.tools.emailValidate')}</MuiLink>
                <MuiLink component={RouterLink} to="/tools/spf-check" sx={{ color: tokens.color.textSecondary }}>SPF</MuiLink>
                <MuiLink component={RouterLink} to="/tools/dmarc-check" sx={{ color: tokens.color.textSecondary }}>DMARC</MuiLink>
              </Stack>
            </Stack>
          </Stack>
          <Typography variant="caption" sx={{ display: 'block', mt: 4, color: tokens.color.textMuted }}>
            © {new Date().getFullYear()} EmailValidator. {t('footer.rights')}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};
